// extracted by mini-css-extract-plugin
export default {"text":"Text_text__C3ogs","sm":"Text_sm__5n4xc","md":"Text_md__oehay","lg":"Text_lg__6cYQG","xl":"Text_xl__A3b2G","xxl":"Text_xxl__8eH5x","truncate":"Text_truncate__bjXJ7"};